import React, { useEffect } from 'react';

import { AuthService, Container, LeagueRank } from '../../../../symphony';

import { SlLEContext } from '../../global-constants';
import { SlDataService } from '../../services/sl-data.service';
import { SlActions } from '../../services/ActionsService/sl-actions';
import {
	ActionType,
	ILeaderboardUserWithPos,
	RequestType,
} from '../../global-interface';
import { useEnterKeyPress } from '../../utils/useEnterKeyPress';
import { SlLeaderboardCelebrationScreen } from '../../../../shared/public/SlLeaderboardCelebrationScreen/SlLeaderboardCelebrationScreen';

export function LeaderboardCelebration() {
	const { leaderboardStates, leagueRank } = Container.take(
		SlLEContext,
		SlDataService,
	);
	const { actions$ } = Container.take(SlLEContext, SlActions);
	const authService = Container.take('global', AuthService);
	const userId = authService.getUser()?.id;

	useEffect(() => {
		actions$.next({
			type: ActionType.OnLeaderboardScreenMount,
			requestType: RequestType.Parallel,
		});

		return () => {
			actions$.next({
				type: ActionType.OnLeaderboardScreenUnmount,
				requestType: RequestType.Parallel,
			});
		};
	}, []);

	const findUserPosition = () => {
		const user = leaderboardStates.predictedState.find(
			(item: ILeaderboardUserWithPos) => item?.userId === userId,
		);
		return (user as ILeaderboardUserWithPos).position;
	};

	const onLeaderboardContinue = () => {
		actions$.next({
			type: ActionType.OnLeaderboardScreenContinueClick,
			requestType: RequestType.Parallel,
		});
	};

	const goToLeaderboard = () => {
		actions$.next({
			type: ActionType.OngoToLeaderboardClick,
			requestType: RequestType.Parallel,
		});
	};

	useEnterKeyPress(onLeaderboardContinue);

	return leaderboardStates ? (
		<SlLeaderboardCelebrationScreen
			onContinue={onLeaderboardContinue}
			goToLeaderboard={goToLeaderboard}
			place={findUserPosition()}
			leagueName={LeagueRank[leagueRank]}
			previouseLeaderboardUsers={leaderboardStates.currentState}
			currentLeaderboardUsers={leaderboardStates.predictedState}
			userId={String(userId)}
		/>
	) : null;
}
